import React from 'react'
import { feedbotToast } from '../toastDispatchers'
import { Subtitle } from '../ToastLayout'

export const toastNotifyInvalidJsonError = () => {
  const title = 'Invalid JSON'

  const content = (
    <Subtitle>
      You probably made a mistake during editing in the JSON editor. Please check it; our editor
      will help you discover errors. Then try to save it again.
    </Subtitle>
  )

  feedbotToast.error({ title, content })
}
